import AddIntake from "../../Components/Modals/AddIntake";
import AddSkill from "../../Components/Modals/AddSkill";
import Table from "../../Components/Table";
import { deleteIntakeById, getAllIntake } from "../../Services/MasterService";

const Intake = () => {
    const columns = [
        {
            label: "Name",
            value: "name"
        },
        {
            label: "Alias",
            value: "alias"
        }
    ];

    const renderAddModal = (openAddModal, setOpenAddModal) => {
        return (
            <AddIntake data={openAddModal} onClose={() => setOpenAddModal()} onCloseWithApi={() => setOpenAddModal(true)} />
        )
    };

    return (
        <Table
            api={getAllIntake}
            columns={columns}
            title={"Intake Master"}
            addModal={renderAddModal}
            showAddButton={true}
            showExportButton={true}
            deleteApi={deleteIntakeById}
        />
    );
}

export default Intake;